/* eslint-disable @ok/oklint/no-hardcode-variable */

import { get } from '@common/utils/dataProxy';

export const APPLICATION_PAGE_BASE = '/yutai/application';

// ---------------------------------------------------------------------------
// Company IDs
// ---------------------------------------------------------------------------

export const CompanyCode = {
  AIFusion: 1,
  MetaPlanet: 2,
  AIStorm: 3,
} as const;

export type CompanyCodeValue = (typeof CompanyCode)[keyof typeof CompanyCode];

// ---------------------------------------------------------------------------
// Shared APIs
// ---------------------------------------------------------------------------

/**
 * Fetch shareholder benefit pre-info for a given company.
 * Used to get apply deadline text, button states, etc.
 * Endpoint: /v3/users/shareholders/pre-info
 */
export const fetchPreInfo = async (
  companyId: number
): Promise<Record<string, unknown> | null> => {
  try {
    const res = await fetch(
      `/v3/users/shareholders/pre-info?companyId=${encodeURIComponent(
        companyId
      )}`
    );
    if (!res.ok) return null;
    const json = await res.json();
    return json?.code === 0 ? json.data : null;
  } catch {
    return null;
  }
};

/**
 * Fetch the current logged-in user's ASP info (userId for telemetry).
 */
export const fetchAspUserId = async (): Promise<string> => {
  try {
    const res = await get('/v3/users/asp', {}, false);
    return (res as { userId?: string })?.userId || '';
  } catch {
    return '';
  }
};

/**
 * Check whether a company's shareholder benefit landing page should be published.
 * Endpoint: /v2/support/shareholders/is-open
 */
export const fetchShouldPagePublish = async (
  companyId: number
): Promise<boolean> => {
  if (window.location.hostname === 'localhost') return true; // For local development, always return true to avoid unnecessary 404 redirection
  try {
    const res = await fetch(
      `/v2/support/shareholders/is-open?companyId=${encodeURIComponent(
        companyId
      )}`
    );
    if (!res.ok) return false;
    const json = await res.json();
    return json?.code === 0 ? json.data : true;
  } catch {
    return false;
  }
};
